import React from 'react';

import SingUp from "../components /SignUP";

const SignUpPage = () => {

    return (

        <div>
            <SingUp  />
        </div>
    )
}

export default SignUpPage

